<template>
  <div
    @click="$emit('close')"
    v-if="message"
    class="p-3 bg-gray-800 rounded text-white cursor-pointer"
    :class="{
      'bg-green-600': type === 'success',
      'bg-red-600': type === 'error',
      'bg-blue-600': type === 'info',
    }"
  >
    {{ message }}
  </div>
</template>

<script setup>
defineEmits(['close'])

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: 'info',
  },
})
</script>
